module.exports = __webpack_public_path__ + "static/source-sans-3-regular.74bf9224.woff";